import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  signedDocumentToken: null,
  signedDocumentId: null,
  documentStatus: 'DRAFT', // 'DRAFT', 'PENDING', 'COMPLETED', 'ERROR'
  signedDocumentError: '',
  isSignModalOpen: false,
  requiresSignedDocument: false,
  isSubmitting: false,
  isProcessing: false,
  isPaymentMethodComplete: false,
  isTermsChecked: false,
  termsError: '',
  customForm: {
    email: '',
    firstName: '',
    lastName: ''
  },
  customFormError: {
    email: '',
    firstName: '',
    lastName: ''
  }
};

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setSignedDocumentToken: (state, action) => {
      state.signedDocumentToken = action.payload;
    },
    setSignedDocumentId: (state, action) => {
      state.signedDocumentId = action.payload;
    },
    setDocumentStatus: (state, action) => {
      state.documentStatus = action.payload;
    },
    setSignedDocumentError: (state, action) => {
      state.signedDocumentError = action.payload;
    },
    setIsSignModalOpen: (state, action) => {
      state.isSignModalOpen = action.payload;
    },
    setRequiresSignedDocument: (state, action) => {
      state.requiresSignedDocument = action.payload;
    },
    resetCheckout: (_state, action) => ({
      ...initialState,
      requiresSignedDocument:
        action.payload?.requiresSignedDocument ??
        initialState.requiresSignedDocument
    }),
    setCustomForm: (state, action) => {
      state.customForm = action.payload;
    },
    setCustomFormError: (state, action) => {
      state.customFormError = action.payload;
    },
    setIsSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setIsProcessing: (state, action) => {
      state.isProcessing = action.payload;
    },
    setIsPaymentMethodComplete: (state, action) => {
      state.isPaymentMethodComplete = action.payload;
    },
    setIsTermsChecked: (state, action) => {
      state.isTermsChecked = action.payload;
    },
    setTermsError: (state, action) => {
      state.termsError = action.payload;
    }
  }
});

const { actions, reducer } = checkoutSlice;

export const {
  setSignedDocumentToken,
  setSignedDocumentId,
  setDocumentStatus,
  setSignedDocumentError,
  setIsSignModalOpen,
  setRequiresSignedDocument,
  resetCheckout,
  setCustomForm,
  setCustomFormError,
  setIsSubmitting,
  setIsProcessing,
  setIsPaymentMethodComplete,
  setIsTermsChecked,
  setTermsError
} = actions;

export default reducer;
